module.exports = __webpack_public_path__ + "img/16.missing_toilet_paper.d4c217d9.svg";